import { AxiosError, AxiosResponse } from 'axios';

import { LogLevel, logger } from '@/shared/utils';

export const handleAxiosError = (error: AxiosError): void => {
  const { status, statusText, data, headers } = error.response as AxiosResponse;

  logger(LogLevel.ERROR, error, {
    message: 'clientAxios onResponseError',
    detail: {
      status,
      statusText,
      data,
      url: headers.location,
      userAgent: headers['user-agent'] || 'unknown',
      referer: headers.referer || 'unknown',
      stack: error.stack || 'unknown',
      request: {
        method: error.config?.method || 'unknown',
        url: error.config?.url || 'unknown',
        headers: error.config?.headers || 'unknown',
      },
      path: error.config?.url || 'unknown',
      query: error.config?.params || 'unknown',
      body: error.config?.data || 'unknown',
    },
  });
};

export const logUnknownError = (error: Error): void => {
  logger(LogLevel.ERROR, error, {
    message: 'clientAxios unknown onResponseError',
    detail: {
      message: error.message,
      stack: error instanceof Error ? error.stack : 'unknown',
      error,
    },
  });
};
